export default __webpack_public_path__ + "images/de8e07b85844675f68f64488a80efe98-media.jpg";